module.exports = __webpack_public_path__ + "img/flecha_atras.0500d797.svg";